import Avatar from 'components/base/Avatar';
import { Dropdown, Nav } from 'react-bootstrap';
import avatar57 from 'assets/img/team/avatar-rounded.webp';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from 'providers/AuthProvider';
import { getAuthRole, getAuthSession } from 'features/auth/authSession';

const NavItems = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();  // Add isAuthenticated and user here
  const role = getAuthRole();
  const session = getAuthSession();
  const displayName = `${user?.name} ${user?.last_name}` || session?.user.email || 'User';
  const roleLabel = role;

  const profilePath =
    role === 'pharmacy'
      ? '/dashboard/pharmacy/profile'
      : '/dashboard/locum/profile';

  const handleLogout = async () => {
    await logout();
    if (role === 'admin') {
      navigate('/auth/admin-login', { replace: true });
    } else {
      navigate('/auth/login', { replace: true });
    }
  };

  return (
    <div className="navbar-nav navbar-nav-icons flex-row align-items-center gap-3">
      <Nav.Item className="d-none d-md-flex align-items-center me-1">
        <div className="d-flex flex-column align-items-end">
          <span
            className="fw-bold fs-8 text-body-emphasis font-sans-serif text-truncate mb-1"
            style={{ maxWidth: 220, lineHeight: 1.2 }}
            title={displayName}
          >
            {displayName}
          </span>
          <span className="text-body-tertiary fs-9">
            {roleLabel?.charAt(0).toUpperCase()}{roleLabel?.slice(1)}
          </span>
        </div>
      </Nav.Item>
      <Nav.Item>
        <Dropdown align="end" autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link pe-0 py-0 lh-1 h-100 d-flex align-items-center"
            variant=""
          >
            <Avatar src={avatar57} size="l" />
          </Dropdown.Toggle>
          <Dropdown.Menu className="navbar-dropdown-caret py-2 shadow border">
            <Dropdown.Item as={Link} to={profilePath}>
              Profile
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Nav.Item>
    </div>
  );
};

export default NavItems;